export default __webpack_public_path__ + "static/media/magicna-kreativnost.a7f7524d.gif";